






















































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNensan from '@/components/common/control/CtrlNensan.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlNormalTxt from '@/components/common/control/CtrlNormalTxt.vue';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import {
  HimmokuShuruiPtn,
  ShoriKb,
  TaishoFlg,
  UmuFlg,
} from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import {
  calcWeight,
  convertStr2Num,
  isShorikbADD,
  isShorikbREFER,
  isShorikbUPD,
} from '@/utils/utils';
import moment from 'moment';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import CtrlHimmoku from '../common/search/CtrlHimmoku.vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_090_ZaikoIdoIraiEntry_ChildDetailInput',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
    CtrlNormalTxt,
    CtrlNumTxt,
    CtrlNensan,
    CtrlHimmoku,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    shoriKb: {
      type: Number,
      default: ShoriKb.ADD,
    },
    childItem: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    BUTTON,
    UmuFlg,
    HimmokuShuruiPtn,
    TaishoFlg,

    childDetailInput: {
      himmokuCd: 0,
      nensan: 0,
      idoSuryo: 0,
      idoJuryo: 0,
      meisaiBiko: '',
    },
    himmokuItem: null,
    mounted: false,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    yearOfGenzaiYmd() {
      return Number(
        moment(this.userInfo.onlineData.genzaiYmd.toString()).format('YYYY')
      );
    },
    isAdd() {
      return isShorikbADD(this.shoriKb);
    },
    isRef() {
      return isShorikbREFER(this.shoriKb);
    },
    isUpd() {
      return isShorikbUPD(this.shoriKb);
    },
    tani() {
      return this.himmokuItem ? this.himmokuItem.tani : '';
    },
    irisu() {
      return this.himmokuItem ? this.himmokuItem.irisu : '';
    },
    himmokuMei() {
      return this.himmokuItem ? this.himmokuItem.himmokuMei1 + (this.himmokuItem.himmokuMei2 ? ' ' + this.himmokuItem.himmokuMei2 : '') : '';
    },
  },
  watch: {
    'childDetailInput.idoSuryo': {
      handler(val) {
        this.childDetailInput.idoSuryo = convertStr2Num(val);
        this.handleCalcWeight();
      },
    },
  },
  methods: {
    convertStr2Num,
    hide() {
      this.$emit('update:show', false);
    },
    handleCalcWeight() {
      if (!this.mounted || !this.himmokuItem) return;

      this.childDetailInput.idoJuryo = calcWeight(
        this.himmokuItem ? this.himmokuItem.caseWeight : 0,
        convertStr2Num(this.childDetailInput.idoSuryo),
        0,
        0
      );
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
    },
    initValues() {
      this.childDetailInput = {
        ...this.childDetailInput,
        ...this.childItem,
      };
    },
    handleDelete() {
      this.hide();
      this.$emit('delete-item', this.childDetailInput);
    },
    callbackOkHimmoku(item: any) {
      if (item && item.himmokuCd) {
        this.himmokuItem = item;
        this.childDetailInput.himmokuCd = item.himmokuCd;
        if (item.nensanKanriKb === UmuFlg.NASHI) {
          this.childDetailInput.nensan = 0;
        }
      } else {
        // 単位、入数、数量、重量、年産
        this.himmokuItem = null;
        this.childDetailInput.himmokuCd = 0;
        this.childDetailInput.idoSuryo = 0;
        this.childDetailInput.idoJuryo = 0;
        this.childDetailInput.nensan = 0;
      }
      this.handleCalcWeight();
    },
    async checkValidate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();

      if (!this.childDetailInput.himmokuCd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['品目'];
        this.messageShow = true;
        return;
      }
      if (!convertStr2Num(this.childDetailInput.idoSuryo)) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['数量'];
        this.messageShow = true;
        return;
      }
      if (convertStr2Num(this.childDetailInput.idoSuryo) < 0) {
        this.messageId = 'KI_W108';
        this.messageTextParam = ['数量はマイナス値'];
        this.messageShow = true;
        return;
      }
      if (this.childDetailInput.nensan > this.yearOfGenzaiYmd) {
        this.messageId = 'KI_W109';
        this.messageTextParam = ['年産', '未来年'];
        this.messageShow = true;
        return;
      }
      if (convertStr2Num(this.childDetailInput.idoJuryo) > 9999999.99) {
        this.messageId = 'KI_W122';
        this.messageTextParam = ['重量'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      const newItem = {
        himmokuCd: this.childDetailInput.himmokuCd,
        himmokuMei: this.himmokuMei,
        tani: this.tani,
        irisu: this.irisu,
        idoSuryo: convertStr2Num(this.childDetailInput.idoSuryo),
        idoJuryo: convertStr2Num(this.childDetailInput.idoJuryo),
        nensan: this.childDetailInput.nensan,
        meisaiBiko: this.childDetailInput.meisaiBiko,
        ...(this.isUpd && {
          index: this.childDetailInput.index, // only Upd
        }),
      };
      this.hide();
      this.$emit('save-item', newItem);
    },
  },
  async created() {
    this.initValues();
  },
  mounted() {
    setTimeout(() => {
      this.mounted = true;
    });
  },
});
